import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { TooltipProvider } from "components/ui/tooltip";

import { BlockDialog } from "./components/block-dialog";
import { ErrorState } from "./components/error-state";
import { HistoryPanel } from "./components/history-panel";
import { MiniYearCalendar } from "./components/mini-year-calendar";
import { MonthGrid } from "./components/month-grid";
import { ReleaseDialog } from "./components/release-dialog";
import { YearNavigator } from "./components/year-navigator";
import { usePeriodGate } from "./hooks/use-period-gate";

export function PeriodGatePage() {
  const ctrl = usePeriodGate();

  const showBento =
    !ctrl.isLoading && !ctrl.isError && ctrl.months && ctrl.months.length > 0;

  return (
    <TooltipProvider delayDuration={200}>
      <PageLayout>
        <PageTitle
          title="Controle de Meses Fiscais"
          description="Gerencie a liberação e bloqueio de períodos fiscais para extração"
        />
        <ContentContainer>
          <div className="flex flex-col gap-8">
            <YearNavigator
              selectedYear={ctrl.selectedYear}
              stats={ctrl.stats}
              onPrev={() => ctrl.setSelectedYear((y) => y - 1)}
              onNext={() => ctrl.setSelectedYear((y) => y + 1)}
            />

            {ctrl.isError && <ErrorState onRetry={ctrl.refetch} />}

            {!ctrl.isError && (
              <MonthGrid
                views={ctrl.monthViews}
                isLoading={ctrl.isLoading}
                selectedYear={ctrl.selectedYear}
                currentYear={ctrl.currentYear}
                currentMonth={ctrl.currentMonth}
                onCardClick={ctrl.openDialog}
              />
            )}

            {showBento && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <HistoryPanel entries={ctrl.recentHistory} />
                <MiniYearCalendar
                  years={ctrl.yearsWithData}
                  months={ctrl.months!}
                  currentMonth={ctrl.currentMonth}
                  currentYear={ctrl.currentYear}
                  selectedYear={ctrl.selectedYear}
                  onYearClick={ctrl.setSelectedYear}
                />
              </div>
            )}
          </div>

          <ReleaseDialog
            open={ctrl.dialogAction === "release"}
            target={ctrl.dialogTarget}
            observation={ctrl.observation}
            isLoading={ctrl.isReleasing}
            onObservationChange={ctrl.setObservation}
            onClose={ctrl.closeDialog}
            onConfirm={ctrl.handleRelease}
          />

          <BlockDialog
            open={ctrl.dialogAction === "block"}
            target={ctrl.dialogTarget}
            isLoading={ctrl.isBlocking}
            onClose={ctrl.closeDialog}
            onConfirm={ctrl.handleBlock}
          />
        </ContentContainer>
      </PageLayout>
    </TooltipProvider>
  );
}

export default PeriodGatePage;
